import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-alert-user-feedback',
  templateUrl: './alert-user-feedback.component.html',
  styleUrls: ['./alert-user-feedback.component.scss']
})
export class AlertUserFeedbackComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
